import { apiRequest, apiEndPoints, methodType } from "./_apiConfig";
import { postFormWithPasswordPrompt } from "./pdf_upload";

export const getDocumentsListRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.documentsList,
    data,
    true,
    true
  );
};

export const getDocumentTypesListRequest = async ({ category, business_type_id } = {}) => {
  const params = {};
  if (category) params.category = category;
  if (business_type_id) params.business_type_id = business_type_id;

  const queryParams = new URLSearchParams(params).toString();
  const endpoint = queryParams
    ? `${apiEndPoints.documentTypesList}?${queryParams}`
    : apiEndPoints.documentTypesList;

  return apiRequest(
    methodType.GET,
    endpoint,
    {},
    true,
    false
  );
};

export const uploadDocumentRequest = async (formData) => {
  return postFormWithPasswordPrompt(apiEndPoints.documents, formData);
};

export const uploadDocumentFilesRequest = async (documentId, formData) => {
  return postFormWithPasswordPrompt(
    apiEndPoints.documentFiles(documentId),
    formData
  );
};

export const deleteDocumentRequest = async (documentId, loanId) => {
  return apiRequest(
    methodType.DELETE,
    apiEndPoints.eachDocument(documentId),
    {},
    true,
    false
  );
};

export const deleteFileRequest = async (fileId) => {
  return apiRequest(
    methodType.DELETE,
    apiEndPoints.deleteFile(fileId),
    null,
    true,
    false
  );
};
